import React, { useState } from 'react';
import { Container, Box, Grid, TextField, Button, Typography, Checkbox, Link, Radio, RadioGroup, FormControlLabel, FormControl } from '@mui/material';
import logo from '../../assets/Images/Clanbridge-logo.png2.png';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthHeader from '../../Auth';
import axiosInstance from '../../lib/axios';

const MaintenanceLogin = () => {
    const navigate = useNavigate();
    const [mobileNumber, setMobileNumber] = useState('');
    const [loginMethod, setLoginMethod] = useState('user'); // Default to 'user'
    const [errors, setErrors] = useState({});

    const handleValidation = () => {
        const newErrors = {};
        if (!mobileNumber) {
            newErrors.mobileNumber = 'Mobile Number is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogin = async () => {
        if (!handleValidation()) return;
   
        try {
            let apiUrl = '';
            let payload = {};

            if (loginMethod === 'user') {
                // User API
                apiUrl = `userMst/Getuserchkmob`;
                payload = { mobileNo: mobileNumber };
            } else {
                // Resident API
                apiUrl = `ResidentMst/RetriveResidentMstAll`;
                payload = {
                    ResidentId: 1,
                    Flag: "M",
                    Mobile: mobileNumber,
                };
            }

            const response = await axiosInstance.post(apiUrl, payload);
            console.log("rees",response);
            if ( response.data.Status === 0) {
                const userName =
                    loginMethod === 'user'
                        ? response.data.Data.UserName
                        : response.data.Data.MstResidentList[0].FirstName;
                        
                        const mobileNo =
                loginMethod === 'user'
                    ? response.data.Data.MobileNo // For User/Warden, fetch MobileNo
                    : response.data.Data.MstResidentList[0].Mobile; 

                    const userId =
                    loginMethod === 'user'
                        ? response.data.Data.UserId // Assuming UserId is available in response for User
                        : response.data.Data.MstResidentList[0].ResidentId;

                if (!userName) {
                    const errorMessage =
                        loginMethod === 'user'
                            ? 'Invalid mobile number. Please try again.'
                            : 'Login failed. No record found.';
                    toast.error(errorMessage, {
                        position: 'top-right',
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                    return;
                }

                // Store session and redirect
                localStorage.setItem('userName', userName);
                localStorage.setItem('loginType', loginMethod); 
                localStorage.setItem('mobileNumber', mobileNo);
                localStorage.setItem('UserId', userId);
                localStorage.setItem('isLoggedIn', 'true');
            
                toast.success('Login Successful!', {
                    position: 'top-right',
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });

                setTimeout(() => navigate('/tkt-dashboard'), 2000);
            } else {
                toast.error('Login failed: ' + (response.data.Message || 'Invalid credentials'), {
                    position: 'top-right',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
            }
        } catch (error) {
            console.error('Login error:', error);
            toast.error('An error occurred during login.', {
                position: 'top-right',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    };

    return (
        <Box className="main_login">
            <ToastContainer />
            <Container className="main_container">
                <Grid container spacing={2} alignItems="center" justifyContent="center" className="middle_container">
                    <Grid item xs={12} md={6}>
                        <Box display="flex" flexDirection="column" justifyContent="center">
                            <img src={logo} alt="logo" className="loginLogo" style={{ width: '100%', maxWidth: '200px' }} />
                            <Typography
                                variant="h4"
                                gutterBottom
                                className="mb-4"
                                sx={{ fontSize: { xs: '18px', sm: '20px', md: '25px' }, marginTop: '10px' }}
                            >
                                Welcome to Clanbridge!
                            </Typography>
                            <Typography variant="h6" gutterBottom className="mb-4">
                                Maintenance Login
                            </Typography>
                            <FormControl component="fieldset">
                                <RadioGroup row value={loginMethod} onChange={(e) => setLoginMethod(e.target.value)}>
                                    <FormControlLabel value="user" control={<Radio />} label="User" />
                                    <FormControlLabel value="resident" control={<Radio />} label="Resident" />
                                </RadioGroup>
                            </FormControl>

                            <Typography
                                variant="subtitle1"
                                style={{
                                    fontWeight: 550,
                                    color: '#29343d',
                                    fontSize: '15px',
                                    marginBottom: '5px',
                                }}
                            >
                                {loginMethod === 'user' ? 'User' : 'Resident'} Mobile Number
                            </Typography>
                            <TextField
                                type="text"
                                variant="outlined"
                                placeholder="Enter Mobile Number"
                                fullWidth
                                value={mobileNumber}
                                onChange={(e) => setMobileNumber(e.target.value)}
                                error={Boolean(errors.mobileNumber)}
                                helperText={errors.mobileNumber}
                            />

                            <Box className="py-2" display="flex" justifyContent="space-between" alignItems="center">
                                <Box display="flex" alignItems="center">
                                    <Checkbox size='small' className="check_box" />
                                    <Typography
                                        variant="body2"
                                        className="mx-2"
                                        sx={{ fontSize: { xs: '12px', sm: '14px', md: '16px' } }}
                                    >
                                        Keep me logged in
                                    </Typography>
                                </Box>
                                <Link href="#" sx={{ fontSize: '14px', color: 'blue' }}>
                                    Forget Mobile Number?
                                </Link>
                            </Box>
                            <Button
                                // onClick={handleLogin}
                                className="button_signin"
                                variant="contained"
                                fullWidth
                                style={{ marginTop: 16 }}
                            >
                                Sign In
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default MaintenanceLogin;
